import { render, staticRenderFns } from "./AvailableDocumentsDataTable.vue?vue&type=template&id=108db4b6"
import script from "./AvailableDocumentsDataTable.vue?vue&type=script&lang=js"
export * from "./AvailableDocumentsDataTable.vue?vue&type=script&lang=js"
import style0 from "./AvailableDocumentsDataTable.vue?vue&type=style&index=0&id=108db4b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports